"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToyotaType = void 0;
var _typography = _interopRequireDefault(require("../../packages/typography"));
var _toyota = _interopRequireDefault(require("./toyota.typography"));
const {
  ToyotaType
} = (0, _typography.default)(_toyota.default);
exports.ToyotaType = ToyotaType;
var _default = exports.default = {
  ToyotaType
};